<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/logo/logo-black.png"></navbar>
      <div class="st-FixedPoint"></div>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top: 120px;">

          <nav class="series-Nav sw-stickyTrigger-target">
            <div class="series-Nav_Inner series-Nav_Inner_company">
              <ul class="mb-0">
                <li>
                  <router-link to="/solution/logistics-automation">
                    <img style="object-fit: cover;" height="50" width="50" src="../../../../static/img/home/menu-logistics-automation.jpg" alt="">
                    <h4 class="pl-md-4">ロボティクス自動化ソリューション
                    </h4>
                    <!-- <h4 class="pl-4 pl-md-5 show-sp">
                    </h4> -->
                  </router-link>
                </li>
                <li class="current">
                  <router-link to="/solution/low-code">
                    <img style="object-fit: cover;" height="50" width="50" src="../../../../static/img/home/menu-low-code.jpg" alt="">
                    <h4 class="pl-3 pl-md-4">Lowコードソリューション
                    </h4>
                    <!-- <h4 class="pl-4 pl-md-5 show-sp">
                      ES-FAST
                    </h4> -->
                  </router-link>
                </li>
              </ul>
            </div>
          </nav>

          <header class="series-PageTitle">
            <div class="series-PageTitle_Inner" data-appear>
              <h1>
                <span class="series-PageTitle_Logo">ES-FAST</span>
                <span class="series-PageTitle_Title" style="color:#FFF">Lowコードソリューション</span>
              </h1>
              <div class="sw-parallax">
                <div class="sw-parallax_outer js-parallax_outer">
                  <div class="sw-parallax_inner">
                    <div class="sw-parallax_block js-parallax_block">
                      <div class="sw-parallax_target promotion-PageTitle-visual" style="background: url(../../../../static/img/solution/low-code/top.jpg) 50%/cover no-repeat;top: 70px;height: 480px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <section class="company-Profile">
            <div class="company-Profile_Inner pb-6">
              <div class="st-Grid_Inner p-0 solution-low-code-appear-1" data-appear="true">
                <h2 class="common-text-appear text-center solution-low-code-appear-2" data-appear="true">
                  <span class="sw-Section_Header-en pb-3">
                    <b>
                      <font>
                        <font>ES-FASTのご紹介</font>
                      </font>
                    </b>
                  </span>
                </h2>
              </div>

              <div class="fast-detail-body">
                <div class="fast-detail-column">
                  <div class="content-wrapper-home-fast st-grid-padding">
                    <div class="common-image-appear solution-low-code-appear-3 mt-4" data-appear="true">
                        <picture><img width="100%" src="../../../../static/img/solution/low-code/02.jpg" /></picture>
                      </div>
                  </div>

                  <div class="top-card_Row-common solution-low-code-appear-4 pr-0 pl-0 col-md-6 p-0 mb-0" data-appear>
                    <div class="top-card_Row-text-common solution-low-code-appear-4" data-appear>
                      <div class="px-5 pt-4 pb-3 text">
                        近年、DX推進の必要性が高まっていることで、Lowコード、Noコードという言葉をよく耳にするようになりました。<br /> 
                        弊社の製品ES-FASTは、そのLowコードを使用できるソリューション製品です。
                        プログラミングの専門知識に詳しいIT人材がいなくても、 アプリケーションなどを簡単に作ることが可能です。
                        基本業務機能を持ち、Lowコードで開発ができるツールも搭載しています。 
                        柔軟かつ効率的に業務システムの構築ができ、業務シーンに合わせてお客様自身でもカスタマイズや機能追加ができます。 
                        さらにタブレット、スマートフォンに適した画面も同時に構築が可能です。
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>

          <section class="company-Profile">
            <div class="company-Profile_Inner pt-0 pb-5">
              <div class="st-Grid_Inner p-0 m-0 solution-low-code-appear-5" data-appear="true">
                <h2 class="common-text-appear text-center solution-low-code-appear-6" data-appear="true">
                  <span class="sw-Section_Header-en pb-6">
                    <b>
                      <font>
                        <font>ES-FASTの特徴</font>
                      </font>
                    </b>
                  </span>
                </h2>
              </div>

              <div class="fast-detail-body">
                <div class="fast-detail-column-text-appear swiper-container-home-fast swiper-container swiper-container-home-report-slide-1 common-appear solution-low-code-appear-7 p-0" data-appear>
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <div class="fast-detail-column-text mt-3 pr-0">
                        <div class="text-border-solution text-border-solution-slide-1 px-4 py-2">
                          基本の汎用機能を持ち、小規模な運用業務の<br />システム化が簡単にできる
                        </div>
                      </div>
                      <div class="common-image-appear solution-low-code-appear-7-1 mt-4" data-appear="true">
                        <picture><img width="100%" src="../../../../static/img/solution/low-code/03.jpg" /></picture>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="fast-detail-column-text mt-3 pr-0">
                        <div class="text-border-solution text-border-solution-slide-1 px-4 py-2">
                          Lowコード開発ツールを搭載し、柔軟かつ効率的に<br />システムを構築できる
                        </div>
                      </div>
                      <div class="common-image-appear solution-low-code-appear-7-2 mt-4" data-appear="true">
                        <picture><img width="100%" src="../../../../static/img/solution/low-code/04.jpg" /></picture>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="fast-detail-column-text mt-3 pr-0">
                        <div class="text-border-solution text-border-solution-slide-1 px-4 py-2">
                          PC、タブレット、スマートフォンなど多種多様なデバイスにGUIが適用され、多言語対応も可能
                        </div>
                      </div>
                      <div class="common-image-appear solution-low-code-appear-7-3 mt-4" data-appear="true">
                        <picture><img width="100%" src="../../../../static/img/solution/low-code/05.png" /></picture>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-button-next swiper-container-home-report-slide-1-next"><i class="icf el-icon-arrow-right"></i></div>
                  <div class="swiper-button-prev swiper-container-home-report-slide-1-prev"><i class="icf el-icon-arrow-left"></i></div>
                </div>
              </div>
            </div>
          </section>
          
          <section class="company-Profile">
            <div class="company-Profile_Inner pt-0 pb-6">
              <div class="st-Grid_Inner p-0 m-0 solution-low-code-appear-8" data-appear="true">
                <h2 class="common-text-appear text-center solution-low-code-appear-9 appear" data-appear="true">
                  <span class="sw-Section_Header-en pb-6">
                    <b>
                      <font>
                        <font>開発ツール搭載</font>
                      </font>
                    </b>
                  </span>
                </h2>
              </div>

              <div class="fast-detail-body">
                <div class="fast-detail-column-text-appear swiper-container swiper-container-home-fast swiper-container-home-report-slide-3 common-appear solution-low-code-appear-10 p-0 appear" data-appear>
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <div class="common-image-appear solution-low-code-appear-10-1 mt-5 appear" data-appear="true">
                        <picture>
                          <video width="100%" muted autoplay loop playsinline poster="">
                            <source src="../../../../static/video/es-editor.mp4" type="video/mp4">
                          </video>
                        </picture>
                      </div>
                      <div class="fast-detail-column-text mt-5 pr-0">
                        <div class="p-4">
                          <strong style="font-size: 1.7rem;">ES-EDITORは</strong>、フロントエンドのLowコード画面開発機能。ユーザがドラッグ&ドロップで画面設計や作成を行えるため、
                          イニシャル工数の大幅削減や開発効率の向上ができるだけでなく、自社開発できることでランニング費用も最小限に抑えることができます。
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="common-image-appear solution-low-code-appear-10-1 mt-5" data-appear="true">
                        <picture>
                          <video width="100%" muted autoplay loop playsinline poster="">
                            <source src="../../../../static/video/es-api.mp4" type="video/mp4">
                          </video>
                        </picture>
                      </div>
                      <div class="fast-detail-column-text mt-5 pr-0">
                        <div class="p-4">
                          <strong style="font-size: 1.7rem;">ES-APIは</strong>、バックエンドのLowコードアプリケーション開発ツールです。DB連携はもちろんのこと、他システム連携も可視化ツールにより、簡単に実現が可能です。
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="common-image-appear solution-low-code-appear-10-2 mt-5" data-appear="true">
                        <picture>
                          <video width="100%" muted autoplay loop playsinline poster="">
                            <source src="../../../../static/video/es-report.mp4" type="video/mp4">
                          </video>
                        </picture>
                      </div>
                      <div class="fast-detail-column-text mt-5 pr-0">
                        <div class="p-4">
                          <strong style="font-size: 1.7rem;">ES-REPORTは</strong>、Lowコードを使った帳票作成ツールです。エクセルを編集するように簡単に使用でき、
                          エクセルテンプレートからの作成も可能。さらにデータベースに接続し、マッピングにより簡単に帳票作成が可能です。
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="common-image-appear solution-low-code-appear-10-2 mt-5" data-appear="true">
                        <picture>
                          <video width="100%" muted autoplay loop playsinline poster="">
                            <source src="../../../../static/video/es-designer.mp4" type="video/mp4">
                          </video>
                        </picture>
                      </div>
                      <div class="fast-detail-column-text mt-5 pr-0">
                        <div class="p-4">
                          <strong style="font-size: 1.7rem;">ES-DESIGNERは</strong>、GUIを通じて豊富なデザインテンプレートから、専門知識がなくても様々なフォーマットに合わせて簡単にパンフレット、名刺等コンテンツを作成するツールです。
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-button-next swiper-container-home-report-slide-3-next"><i class="icf el-icon-arrow-right"></i></div>
                  <div class="swiper-button-prev swiper-container-home-report-slide-3-prev"><i class="icf el-icon-arrow-left"></i></div>
                </div>
              </div>
            </div>
          </section>

          <section class="company-Profile">
            <div class="company-Profile_Inner pt-0 pb-6">
              <div class="st-Grid_Inner p-0 m-0 solution-low-code-appear-11" data-appear="true">
                <h2 class="common-text-appear text-center solution-low-code-appear-12" data-appear="true">
                  <span class="sw-Section_Header-en pb-6">
                    <b>
                      <font>
                        <font>様々な課題解決</font>
                      </font>
                    </b>
                  </span>
                </h2>
              </div>

              <div class="fast-detail-body">
                <div class="fast-detail-column-text-appear swiper-container swiper-container-home-fast swiper-container-home-report-slide-2 common-appear solution-low-code-appear-13 p-0 appear" data-appear>
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <div class="common-image-appear solution-low-code-appear-13-1 mt-5 appear" data-appear="true">
                        <picture><img width="100%" src="../../../../static/img/solution/low-code/06.jpg" /></picture>
                      </div>
                      <div class="fast-detail-column-text mt-5 pr-0">
                        <div class="p-4">
                          <p class="title text-center">IT部門・保守担当者</p>
                          開発作業が標準化且つ可視化が可能となり、大幅に効率を向上できる。<br />また、
                          様々なシステム環境の構築を一元化することで、管理作業、運用保守が容易になる。
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="common-image-appear solution-low-code-appear-13-1 mt-5" data-appear="true">
                        <picture><img width="100%" src="../../../../static/img/solution/low-code/07.jpg" /></picture>
                      </div>
                      <div class="fast-detail-column-text mt-5 pr-0">
                        <div class="p-4">
                          <p class="title text-center">業務部門・業務担当者</p>
                          プログラミングのスキルはいらず、ツールから簡単に
                          ドラックアンドドロップで画面の追加、新規帳票の作成をすることができる。現場業務の集計、報告といった作業を簡易にすることが可能。
                        </div>
                      </div>
                    </div>
                    <div class="swiper-slide">
                      <div class="common-image-appear solution-low-code-appear-13-1 mt-5" data-appear="true">
                        <picture><img width="100%" src="../../../../static/img/solution/low-code/08.jpg" /></picture>
                      </div>
                      <div class="fast-detail-column-text mt-5 pr-0">
                        <div class="p-4">
                          <p class="title text-center">経営部門・経営管理</p>
                          LowコードツールでDX対応が容易にでき、<br />イニシャルとランニングコストも削減可能。
                          IT人材不足により高騰する開発人件費を抑えるとともにシステムの内製化を実現することが可能。
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-button-next swiper-container-home-report-slide-2-next"><i class="icf el-icon-arrow-right"></i></div>
                  <div class="swiper-button-prev swiper-container-home-report-slide-2-prev"><i class="icf el-icon-arrow-left"></i></div>
                </div>
              </div>
            </div>
          </section>

        </main>
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList">
            <li class="st-BreadcrumbsList_Item">
              <router-link class="st-BreadcrumbsList_Item-link" to="/">
                <p itemprop="item" aria-current="page"><span itemprop="name">ホーム</span></p>
              </router-link>
            </li>
            <li class="st-BreadcrumbsList_Item">
              <p itemprop="item" aria-current="page"><span itemprop="name">Lowコードソリューション</span></p>
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'
import Swiper from 'swiper/swiper-bundle.js'
import 'swiper/swiper-bundle.css'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {

      new Swiper('.swiper-container-home-report', {
        pagination: {
          el: '.swiper-pagination-fast',
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        },
        loop: true,
        autoplay: true,
      })

      new Swiper('.swiper-container-home-report-slide-1', {
        slidesPerView: 'auto',
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 45
          }
        },
        navigation: {
          nextEl: '.swiper-container-home-report-slide-1-next',
          prevEl: '.swiper-container-home-report-slide-1-prev'
        },
      })

      new Swiper('.swiper-container-home-report-slide-2', {
        slidesPerView: 'auto',
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 45
          }
        },
        navigation: {
          nextEl: '.swiper-container-home-report-slide-2-next',
          prevEl: '.swiper-container-home-report-slide-2-prev'
        },
      })

      let mqles = window.matchMedia('(max-width:768px)')
      if(!mqles.matches){

        $(".swiper-container-home-report-slide-3").removeClass("swiper-container swiper-container-home-fast")
        $(".solution-low-code-appear-10-1").eq(0).parent().addClass("col-md-6 px-0 pl-md-0 pr-md-3")
        $(".solution-low-code-appear-10-1").eq(0).parent().removeClass("swiper-slide").parent().removeClass("swiper-wrapper").addClass("col-12 row mx-0 px-0")

        $(".solution-low-code-appear-10-1").eq(1).parent().removeClass("swiper-slide").addClass("col-md-6 px-0 pr-md-0 pl-md-3")
        $(".solution-low-code-appear-10-2").eq(0).parent().removeClass("swiper-slide").addClass("col-md-6 px-0 pl-md-0 pr-md-3")
        $(".solution-low-code-appear-10-2").eq(1).parent().removeClass("swiper-slide").addClass("col-md-6 px-0 pr-md-0 pl-md-3")

        $(".swiper-container-home-report-slide-3-next").remove()
        $(".swiper-container-home-report-slide-3-prev").remove()
        
      }else{
        new Swiper('.swiper-container-home-report-slide-3', {
          slidesPerView: 'auto',
          breakpoints: {
            0: {
              slidesPerView: 1,
              spaceBetween: 0
            },
            769: {
              slidesPerView: 2,
              spaceBetween: 45
            }
          },
          navigation: {
            nextEl: '.swiper-container-home-report-slide-3-next',
            prevEl: '.swiper-container-home-report-slide-3-prev'
          },
        })
      }

      $(".series-PageTitle_Inner").eq(0).addClass('appear')
      $('.solution-low-code-appear-1').addClass('st-Grid_Inner_appear')
      $('.solution-low-code-appear-2').addClass('appear')
      $('.solution-low-code-appear-3').addClass('appear')
      $('.solution-low-code-appear-4').addClass('appear')
      $('.solution-low-code-appear-5').addClass('st-Grid_Inner_appear')
      $('.solution-low-code-appear-6').addClass('appear')
      // element.offsetHeight
      let beforeScollH = 0
      $(document).scroll(() => {

        if (this.$route.path != '/solution/low-code') {
          return false
        }

        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        let differH = scroH - beforeScollH
        let mql = window.matchMedia('(max-width:768px)')

        if (differH === 0) {
          return false
        }
        beforeScollH = scroH

        if (scroH > 50) {
          $('.st-Header').addClass('isStickyReverse')
          $('.series-Nav').addClass('series-Nav-display')
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.series-Nav').removeClass('series-Nav-display')
          $('.st-Header').removeClass('isStickyReverse')
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (differH > 0) {
          $('.series-Nav').removeClass('series-Nav-display')
          if (scroH > 50 && !$('.st-Hd_Trigger').hasClass('is-active')) {
            $('.st-Header').addClass('isStickyReverse')
            $('.header').css({ 'display': 'none' })
          }
          if (mql.matches) {
            $('.series-Nav').css({ 'padding-top': '0px' })
          }
        } else {
          $('.st-Header').removeClass('isStickyReverse')

          if (scroH > 50) {
            $('.series-Nav').addClass('series-Nav-display')
            if (mql.matches) {
              $('.series-Nav').css({ 'padding-top': '18px' })
            }
          } else {
            if (mql.matches) {
              $('.series-Nav').css({ 'padding-top': '0px' })
            }
          }

          $('.header').css({ 'display': 'block' })
        }

        if (viewW > 769) {

          if (scroH > 300) {
            $('.series-PageTitle_Inner').eq(0).removeClass('appear')
          } else {
            $('.series-PageTitle_Inner').eq(0).addClass('appear')
          }

          if (scroH > 750) {
            $('.solution-low-code-appear-1').removeClass('st-Grid_Inner_appear')
            $('.solution-low-code-appear-2').removeClass('appear')
          } else {
            $('.solution-low-code-appear-1').addClass('st-Grid_Inner_appear')
            $('.solution-low-code-appear-2').addClass('appear')
          }

          if (scroH > 1100) {
            $('.solution-low-code-appear-3').removeClass('appear')
            $('.solution-low-code-appear-4').removeClass('appear')
          } else {
            $('.solution-low-code-appear-3').addClass('appear')
            $('.solution-low-code-appear-4').addClass('appear')
          }

          if (scroH > 1300) {
            $('.solution-low-code-appear-5').removeClass('st-Grid_Inner_appear')
            $('.solution-low-code-appear-6').removeClass('appear')
          } else {
            $('.solution-low-code-appear-5').addClass('st-Grid_Inner_appear')
            $('.solution-low-code-appear-6').addClass('appear')
          }

          if (scroH > 80 && scroH < 1700) {
            $('.solution-low-code-appear-7').addClass('appear')
            $('.solution-low-code-appear-7-1').addClass('appear')
            $('.solution-low-code-appear-7-2').addClass('appear')
            $('.solution-low-code-appear-7-3').addClass('appear')
          } else {
            $('.solution-low-code-appear-7').removeClass('appear')
            $('.solution-low-code-appear-7-1').removeClass('appear')
            $('.solution-low-code-appear-7-2').removeClass('appear')
            $('.solution-low-code-appear-7-3').removeClass('appear')
          }

          if (scroH > 500 && scroH < 1900) {
            $('.solution-low-code-appear-8').addClass('st-Grid_Inner_appear')
            $('.solution-low-code-appear-9').addClass('appear')
          } else {
            $('.solution-low-code-appear-8').removeClass('st-Grid_Inner_appear')
            $('.solution-low-code-appear-9').removeClass('appear')
          }

          if (scroH > 600 && scroH < 3000) {
            $('.solution-low-code-appear-10').addClass('appear')
          }else{
            $('.solution-low-code-appear-10').removeClass('appear')
          }

          if (scroH > 900 && scroH < 2430) {
            $('.solution-low-code-appear-10-1').addClass('appear')
          } else {
            $('.solution-low-code-appear-10-1').removeClass('appear')
          }

          if (scroH > 1500 && scroH < 2880) {
            $('.solution-low-code-appear-10-2').addClass('appear')
          } else {
            $('.solution-low-code-appear-10-2').removeClass('appear')
          }

          if (scroH > 2130 &&  scroH < 3150) {
            $('.solution-low-code-appear-11').addClass('appear')
            $('.solution-low-code-appear-11').addClass('st-Grid_Inner_appear')
            $('.solution-low-code-appear-12').addClass('appear')
          } else {
            $('.solution-low-code-appear-11').removeClass('appear')
            $('.solution-low-code-appear-11').removeClass('st-Grid_Inner_appear')
            $('.solution-low-code-appear-12').removeClass('appear')
          }

          if(scroH > 2230){
            $('.solution-low-code-appear-13').addClass('appear')
            $('.solution-low-code-appear-13-1').addClass('appear')
          }else{
            $('.solution-low-code-appear-13').removeClass('appear')
            $('.solution-low-code-appear-13-1').removeClass('appear')
          }
        } else {
          $('.solution-low-code-appear-1').addClass('st-Grid_Inner_appear')
          $('.solution-low-code-appear-2').addClass('appear')
          $('.solution-low-code-appear-3').addClass('appear')
          $('.solution-low-code-appear-4').addClass('appear')
          $('.solution-low-code-appear-5').addClass('st-Grid_Inner_appear')
          $('.solution-low-code-appear-6').addClass('appear')
          $('.solution-low-code-appear-7').addClass('appear')
          $('.solution-low-code-appear-7-1').addClass('appear')
          $('.solution-low-code-appear-7-2').addClass('appear')
          $('.solution-low-code-appear-7-3').addClass('appear')
          $('.solution-low-code-appear-8').addClass('st-Grid_Inner_appear')
          $('.solution-low-code-appear-9').addClass('appear')
          $('.solution-low-code-appear-10').addClass('appear')
          $('.solution-low-code-appear-10-1').addClass('appear')
          $('.solution-low-code-appear-10-2').addClass('appear')
          $('.solution-low-code-appear-11').addClass('appear')
          $('.solution-low-code-appear-12').addClass('appear')
          $('.solution-low-code-appear-13').addClass('appear')
          $('.solution-low-code-appear-13-1').addClass('appear')
        }
      })
    }
  }
}
</script>
<style scoped src="../../../../static/css/solution.css">
</style>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/solution/low-code.vue